import axios from 'axios'

const url = 'https://api.aerosec.com.tr'
const language = '5988516e10335356fbe21fb7'
// const languageEN = "5988516210335356fbe21fb6"
const token = '720a063643fda845dde8ada5208083f6'

const apiClient2 = axios.create({
  baseURL: url,
  withCredentials: false,
  headers: {
    Authorization: 'Token ' + token,
    'Content-Type': 'application/json'
  }
})

export default {
  getFooter (application, language) {
    return apiClient2.get(
      '/dynamicFields?key=' + 'footer' + '&application=' + application + '&language=' + language + '&isActive=true'
    )
  },
  getNavigation (application, language) {
    return apiClient2.get(
      '/dynamicFields?key=' + 'category' + '&application=' + application + '&language=' + language + '&isActive=true'
    )
  },
  getLinesOfActivity (application, language) {
    return apiClient2.get(
      '/staticpages/categorized/' + 'fields-of-activities' + '?application=' + application + '&language=' + language + '&orderBy=order&isActive=true'
    )
  },
  getCategorizedContent (application, language, slug) {
    return apiClient2.get(
      '/staticpages/categorized/' + slug + '?application=' + application + '&language=' + language + '&isActive=true'
    )
  },
  getNews (application, language) {
    return apiClient2.get(
      '/staticpages/categorized/' + 'latestnews' + '?application=' + application + '&language=' + language + '&isActive=true'
    )
  },
  getAnnouncements (application, language) {
    return apiClient2.get(
      '/staticpages/categorized/' + 'publications' + '?application=' + application + '&language=' + language + '&isActive=true'
    )
  },
  getTAVAcademyInPress (application, language) {
    return apiClient2.get(
      '/staticpages/categorized/' + 'tainpress' + '?application=' + application + '&language=' + language + '&isActive=true'
    )
  },
  getFrequentlyAsked (application, language) {
    return apiClient2.get(
      '/staticpages/categorized/' + 'faq' + '?application=' + application + '&language=' + language + '&isActive=true'
    )
  },
  getOurPrograms (application, language) {
    return apiClient2.get(
      '/staticpages/categorized/' + 'our-programs' + '?application=' + application + '&language=' + language + '&isActive=true'
    )
  },
  getMainSlider (application, language) {
    return apiClient2.get(
      '/sliders' + '?application=' + application + '&language=' + language + '&isActive=true'
    )
  },
  getReferences (application) {
    return apiClient2.get(
      '/staticpages/categorized/' + 'references' + '?application=' + application + '&language=' + language + '&isActive=true'
    )
  },
  getPageDetail (pagedetailslug, application, language) {
    return apiClient2.get(
      '/staticpages/categorized/' + pagedetailslug + '?application=' + application + '&language=' + language + '&isActive=true'
    )
  }
}
